import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BellRinging, CheckCircle } from "@phosphor-icons/react";

export default function WaitlistButton({ session }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "" });
  const [state, setState] = useState("idle");
  const [position, setPosition] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("busy"); setError("");
    try {
      const { data } = await api.post(`/sessions/${session.id}/waitlist`, form);
      setPosition(data.position);
      setState("done");
    } catch (err) {
      setError(err.response?.data?.detail || "Could not join the waitlist. Please try again.");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] uppercase text-[#FFD300]" data-testid={`waitlist-joined-${session.id}`}>
        <CheckCircle size={14} weight="fill" /> On the waitlist{position ? ` · #${position}` : ""} — we'll email you if a seat opens
      </div>
    );
  }

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] uppercase text-[#FFD300] hover:underline" data-testid={`waitlist-open-${session.id}`}>
        <BellRinging size={14} weight="duotone" /> Join waitlist
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap gap-2 items-center" data-testid={`waitlist-form-${session.id}`}>
      <input className="field !py-2 !text-xs w-36" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="waitlist-name" />
      <input className="field !py-2 !text-xs w-48" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="waitlist-email" />
      <button type="submit" disabled={state === "busy"} className="btn-primary !py-2 !px-4 !text-xs" data-testid="waitlist-submit">{state === "busy" ? "…" : "Notify me"}</button>
      {error && <span className="font-mono text-[11px] text-red-400 w-full" data-testid="waitlist-error">{error}</span>}
    </form>
  );
}
